import { useMsal } from '@azure/msal-react';
import {
  Button,
  Card,
  Text,
  Title1,
  tokens,
} from '@fluentui/react-components';
import { PersonAccounts24Regular } from '@fluentui/react-icons';
import { loginRequest } from '../config/authConfig';
import { useTranslation } from '../i18n';

export default function LoginPage() {
  const { instance } = useMsal();
  const { t } = useTranslation();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: 'var(--sup-bg-body, #f5f5f5)',
      }}
    >
      <Card
        style={{
          padding: '48px',
          textAlign: 'center',
          maxWidth: '400px',
        }}
      >
        <div
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: tokens.colorBrandBackground,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
          }}
        >
          <PersonAccounts24Regular
            style={{ fontSize: '40px', color: tokens.colorNeutralForegroundOnBrand }}
          />
        </div>

        <Title1 block style={{ marginBottom: '8px' }}>
          {t('shell.appName')}
        </Title1>

        <Text
          block
          style={{
            color: tokens.colorNeutralForeground3,
            marginBottom: '32px',
          }}
        >
          {t('login.subtitle')}
        </Text>

        <Button
          appearance="primary"
          size="large"
          onClick={handleLogin}
          style={{ width: '100%' }}
        >
          {t('login.signIn')}
        </Button>
      </Card>
    </div>
  );
}
